import React from 'react';
import { Link } from 'react-router-dom';

const WorkshopEmptyState = () => {
  return (
    <div className="ep-empty">
      <div className="ep-empty-icon">🧩</div>
      <h3>No workshops attended yet</h3>
      <p className="ep-muted">You don&apos;t have any assigned workshop history yet. Browse upcoming events to register and start attending workshops.</p>
      <Link className="ep-btn-primary wk-empty-cta" to="/events">
        Browse Upcoming Events
      </Link>
    </div>
  );
};

export default WorkshopEmptyState;
